import createAxiosInstance, { getToken, setAuthToken } from "../axios/axiosCustom"
import Cookies from 'js-cookie'


export async function getRefreshToken(getAccessToken = false){
    const axiosCustom = await createAxiosInstance()

    let refreshToken = Cookies.get('refreshToken')
    try {
      if(!refreshToken) {
        return {setUserLoggedIn: false}
      }

      let accToken = getToken()

      let bearerAccessToken = ''
      if(!accToken || getAccessToken) {
        let resp = await axiosCustom.post('/token', { refreshToken: refreshToken})
        accToken = resp.data.accessToken
        bearerAccessToken = 'Bearer ' + accToken

      } else {
        bearerAccessToken = accToken
      }

      setAuthToken(bearerAccessToken)

      return {setUserLoggedIn: true, setLoginText: true}
  
    } catch(err){
      return {}
      console.warn(err)
      
    }
  }